'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaperToolbar = PaperToolbar;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _layout = require('../../layout');

var _paperToolbar = require('./paper-toolbar.css');

var _paperToolbar2 = _interopRequireDefault(_paperToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @summary A basic toolbar container to display at the top of paper
 */

function PaperToolbar(props) {
  var children = props.children;


  return React.createElement(
    _layout.Box,
    { className: _paperToolbar2.default.root, padding: [0, 25] },
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/paper/components/paper-toolbar.js
// module id = 344
// module chunks = 114276838955818